<template>
    <b-sidebar
        id="package-form-sidebar"
        :visible="isPackageFormSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @shown="getData(packageData)"
        @hidden="resetForm"
        @change="(val) => $emit('update:is-package-form-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <div
                class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
            >
                <h5 class="mb-0">Package Form</h5>
                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="hide"
                />
            </div>
            <validation-observer v-slot="{ validate }" ref="formObserver">
                <b-form
                    class="p-2"
                    @submit.prevent="onSubmit(true)"
                    @reset.prevent="resetForm"
                >
                    <b-tabs v-model="tabIndex">
                        <b-tab title="Content">
                            <b-tabs content-class="mt-1" v-if="langs.length > 0">
                                <b-tab
                                    v-for="(lang, key) in langs"
                                    :key="'tab-' + key"
                                    :title="lang.name"
                                >
                                    <validation-provider
                                        v-slot="{errors, validate}"
                                        :name="'title_' + lang.code"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label="Title"
                                            :label-for="'title_' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'title_' + lang.code"
                                                v-model="Data.title[lang.code]"
                                                autofocus
                                                :state="errors[0] ? false : null"
                                                trim
                                                :placeholder="'title (' + lang.code + ')'"
                                                @input="(value) => { validate(); changeTitle(lang.code, value); }"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        v-slot="{errors, validate}"
                                        :name="'short_description_' + lang.code"
                                        rules="min:0"
                                    >
                                        <b-form-group
                                            label="Short Description"
                                            :label-for="'short_description_' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'short_description_' + lang.code"
                                                v-model="Data.short_description[lang.code]"
                                                autofocus
                                                :state="errors[0] ? false : null"
                                                trim
                                                :placeholder="'short description (' + lang.code + ')'"
                                                @input="validate"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        v-slot="{errors, validate}"
                                        :name="'description_' + lang.code"
                                        rules="min:0"
                                    >
                                        <b-form-group
                                            label="Description"
                                            :label-for="'description_' + lang.code"
                                        >
                                            <quill-editor
                                                :options="editorOptions"
                                                :id="'description_' + lang.code"
                                                :state="errors[0] ? false : null"
                                                v-model="Data.description[lang.code]"
                                                @input="validate"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        v-slot="{errors, validate}"
                                        :name="'slug' + lang.code"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label="Slug"
                                            :label-for="'slug' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'slug' + lang.code"
                                                v-model="Data.slug[lang.code]"
                                                :state="errors[0] ? false : null"
                                                trim
                                                :placeholder="'Slug (' + lang.code + ')'"
                                                @input="validate"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        v-slot="{errors, validate}"
                                        :name="'url' + lang.code"
                                        rules="min:0"
                                    >
                                        <b-form-group
                                            label="Url"
                                            :label-for="'url' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'url' + lang.code"
                                                v-model="Data.url[lang.code]"
                                                autofocus
                                                :state="errors[0] ? false : null"
                                                trim
                                                :placeholder="'url (' + lang.code + ')'"
                                                @input="validate"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                </b-tab>
                            </b-tabs>
                            <hr />
                            <div>
                                <b-button
                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    variant="outline-primary"
                                    class="mr-2"
                                    @click="uploadImage"
                                >
                                    Upload Image
                                </b-button>
                                <file-lists
                                    :is-modal-file-lists-show.sync="isModalFileListsShow"
                                    @refesh="refesh"
                                />
                            </div>
                            <br/>
                            <div>
                                <validation-provider
                                    #default="validationContext"
                                    name="cover_image_id"
                                >
                                    <b-form-group label="Cover Image" label-for="image">
                                        <div id="cover_image_id">
                                            <treeselect
                                                @input="eventSelected"
                                                v-model="model" 
                                                placeholder="Choose Folder"
                                                :reduce="(option) => option.id"
                                                label="title"
                                                :options="folderOptions"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                noChildrenText
                                            />
                                        </div>
                                        <b-form-invalid-feedback>
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>
    
                                <div>
                                    <b-container align-h="center">
                                        <b-row>
                                            <b-col 
                                                cols="3"
                                                v-for="(image, index) in images"
                                                :key="index"
                                                class="pt-2"
                                            >
                                                <img 
                                                    @click="eventSelectedCoverImg(image)"
                                                    :src="image.path"
                                                    width="300"
                                                    height="200"
                                                    :class="selectedCoverImage==null
                                                        ? '' 
                                                        : selectedCoverImage.id == image.id
                                                            ? 'selected-img'
                                                            : 'disable-img'
                                                    "
                                                >
                                                <br/>
                                            </b-col>
                                        </b-row>
                                    </b-container>
                                </div>
                            </div>
                            <div v-if="selectedCoverImage!==null">
                                <hr/>
                                <div>Choose Guide Images</div>
                                <b-container align-h="center">
                                    <b-row>
                                        <b-col 
                                            cols="3"
                                            v-for="(image, index) in images.filter(image => image.id !== selectedCoverImage.id)"
                                            :key="index"
                                            class="pt-2"
                                        >
                                        <img 
                                            @click="eventImgSelected(image)"
                                            :src="image.path"
                                            width="300"
                                            height="200"
                                            :class="selectedImages.some(v => v.id === image.id)? 'selected-img' : ''"
                                        >
                                    </b-col>
                                    <hr/>
                                    </b-row>
                                </b-container>
                                <br/>
                            </div>
                            <br/>
                            <validation-provider
                                #default="validationContext"
                                name="IsActive"
                                rules="min:0"
                            >
                                <b-form-group label="Is Active" label-for="IsActive">
                                <b-form-checkbox
                                    id="isactive"
                                    checked="true"
                                    class="custom-control-success"
                                    v-model="Data.is_active"
                                    switch
                                />
                                <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <repeater-section-form
                                v-if="isPackageFormSidebarActive && packageData"
                                @refesh-list="refeshList"
                                :package-data="packageData"
                                :package-input-content-remove.sync="PackageInputContentRemove"
                                :package-input-content.sync="PackageInputContent"
                            />
                        </b-tab>
                        <b-tab title="SEO">
                            <validation-provider
                              #default="validationContext"
                              name="meta_title"
                              rules="min:0"
                            >
                              <b-form-group label="Meta Title" label-for="meta_title">
                                <b-form-input
                                  id="meta_title"
                                  v-model="Data.meta_title"
                                  autofocus
                                  :state="getValidationState(validationContext)"
                                  trim
                                  placeholder="Meta Title"
                                />
                                <b-form-invalid-feedback>
                                  {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                            <validation-provider
                              #default="validationContext"
                              name="meta_description"
                              rules="min:0"
                              
                            >
                              <b-form-group
                                label="Meta Description"
                                label-for="meta_description"
                              >
                                <b-form-input
                                  id="meta_description"
                                  v-model="Data.meta_description"
                                  autofocus
                                  :state="getValidationState(validationContext)"
                                  trim
                                  placeholder="Meta Description"
                                />
              
                                <b-form-invalid-feedback>
                                  {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                name="meta_keywords"
                                rules="min:0"
                            >
                                <b-form-group
                                label="Meta Keywords"
                                label-for="meta_keywords"
                                >
                                    <b-form-input
                                        id="meta_keywords"
                                        v-model="Data.meta_keywords"
                                        autofocus
                                        :state="getValidationState(validationContext)"
                                        trim
                                        placeholder="Meta Keywords"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-tab>
                    </b-tabs>
                    <div class="d-flex mt-2">
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="outline-success"
                            class="mr-2"
                            type="submit"
                        >
                            Save
                        </b-button>
                        <b-button
                            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                            type="button"
                            variant="outline-danger"
                            @click="hide"
                        >
                            Cancel
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </template>
    </b-sidebar>
</template>

<script>
    import { $themeConfig } from '@themeConfig'
    import {
        BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
        BButton, BTabs, BTab, BCard, BCardText, BFormRadio, BFormRating, BContainer, BRow, BCol,
    } from "bootstrap-vue";
    import { required, alphaNum, email, password,confirmed } from '@validations'
    import { ValidationProvider, ValidationObserver } from "vee-validate";
    import vSelect from "vue-select";
    import store from "@/store";
    import languagesStoreModule from "@/views/languages/languagesStoreModule";
    import folderStoreModule from "../../files/folderStoreModule"
    import formValidation from "@core/comp-functions/forms/form-validation";
    import Ripple from "vue-ripple-directive";
    import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
    import { useToast } from "vue-toastification/composition";
    import { slugify } from "@/@fake-db/utils";
    import { ref, onUnmounted } from "@vue/composition-api";
    // import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { quillEditor } from "vue-quill-editor";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.bubble.css";
    import packageStoreModule from '../packageStoreModule'
    import FileLists from '../../uploadStorage/FileLists.vue'
    import RepeaterSectionForm from '../package-form/RepeaterSectionForm.vue'
    import packageSectionStoreModule from '../packageSectionStoreModule';
    import packageBlockStoreModule from '../packageBlockStoreModule'

    export default {
        components: {
            BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
            BButton, BTabs, BTab, BCard, BCardText, vSelect, ValidationProvider, BRow, BCol,
            ValidationObserver, quillEditor, BFormRadio, BFormRating, Treeselect, BContainer, FileLists,
            RepeaterSectionForm,
        },

        directives: {
            Ripple,
        },

        model: {
            prop: "isPackageFormSidebarActive",
            event: "update:is-package-form-sidebar-active",
        },

        props: {
            isPackageFormSidebarActive: {
                type: Boolean,
                required: true,
            },
            packageData: {
                type: Object,
                required: false,
            },
        },

        computed: {
            currentLocale() {
                return this.$i18n.locale;
            },
            folderOptions(){
                return this.folders.map((folder) => this.formatFolder(folder))
            },
            editorOptions (){
                return $themeConfig.snowOption
            }
        },

        methods: {
            formatFolder(folder){
                return{
                    id: folder.id,
                    label: folder.title,
                    children: folder.subFolders.length? folder.subFolders.map(this.formatFolder): undefined
                }
            }
        },

        setup(props, { emit }){
            const {  appRef } = $themeConfig.app
            const toast = useToast();
            const folders = ref([])
            const tabIndex = ref(0);
            const langs = ref([]);
            const parent = ref(0);
            const selected = ref("")
            const images = ref([])
            const selectedCoverImage = ref(null)
            const selectedImages = ref([])
            const model = ref(null)
            const isModalFileListsShow = ref(false)
            const PackageInputContentRemove = ref([])
            const PackageInputContent = ref([])
            const formObserver = ref(null);

            const LANGUAGES_STORE_MODULE_NAME = "app-languages";
            if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule);
            onUnmounted(() => {
            if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME);
            });

            const FOLDER_STORE_MODULE_NAME = 'files-folder'
            if (!store.hasModule(FOLDER_STORE_MODULE_NAME)) store.registerModule(FOLDER_STORE_MODULE_NAME, folderStoreModule)
            onUnmounted(() => {
                if (store.hasModule(FOLDER_STORE_MODULE_NAME)) store.unregisterModule(FOLDER_STORE_MODULE_NAME)
            });

            const PACKAGE_STORE_MODULE_NAME = 'app-packages'
            if (!store.hasModule(PACKAGE_STORE_MODULE_NAME)) store.registerModule(PACKAGE_STORE_MODULE_NAME, packageStoreModule)
            onUnmounted(() => {
                if (store.hasModule(PACKAGE_STORE_MODULE_NAME)) store.unregisterModule(PACKAGE_STORE_MODULE_NAME)
            });

            const CONTENT_STORE_MODULE_NAME = 'packages-section';
            if (!store.hasModule(CONTENT_STORE_MODULE_NAME)) store.registerModule(CONTENT_STORE_MODULE_NAME, packageSectionStoreModule)
            onUnmounted(() => {
                if (store.hasModule(CONTENT_STORE_MODULE_NAME)) store.unregisterModule(CONTENT_STORE_MODULE_NAME)
            });

            const BLOCK_STORE_MODULE_NAME = 'packages-block';
            if (!store.hasModule(BLOCK_STORE_MODULE_NAME)) store.registerModule(BLOCK_STORE_MODULE_NAME, packageBlockStoreModule)
            onUnmounted(() => {
                if (store.hasModule(BLOCK_STORE_MODULE_NAME)) store.unregisterModule(BLOCK_STORE_MODULE_NAME)
            });

            const userStorage = JSON.parse(localStorage.getItem('userData'));
            const getLocalSite = JSON.parse(localStorage.getItem('site'))

            const blankData = {
                meta_title: '',
                meta_description: '',
                meta_keywords: '',
                title: {},
                short_description: {},
                description: {},
                slug: {},
                url: {},
                cover_image: [],
                files: [],
                is_active: true,
                created_by: userStorage.id,
                sites_id: getLocalSite.id
            }

            const Data = ref(blankData)

            const resetData = () => {
                Data.value = blankData;
            };

            const getData = async function(data) {
                await store.dispatch('files-folder/getFolders', {
                    parent: parent.value,
                    order_by:'ordering_count ASC'
                })
                    .then(response => {
                        const res = response.data.data

                        folders.value = res
                })

                model.value = null
                images.value = []
                selectedCoverImage.value = null
                selectedImages.value = []

                Data.value.meta_title = ''
                Data.value.meta_description = ''
                Data.value.meta_keywords = ''
                Data.value.title = {}
                Data.value.description = {}
                Data.value.short_description = {}
                Data.value.slug = {}
                Data.value.url = {}
                Data.value.is_active = true

                if(data){
                    data.is_active = data.is_active? true: false

                    Data.value = data

                    if(data.files.length){
                        const files = data.files
                        const folderId = files[0].folder_id

                        await store.dispatch('files-folder/getFolderById', folderId)
                            .then(response => {
                                const res = response.data.data
                                images.value = res[0].images
    
                                model.value = folderId
                                for(const file of files){
                                    if(file.is_feature){
                                        selectedCoverImage.value = file
                                    } else {
                                        selectedImages.value.push(file)
                                    }
                                }
                            }
                        )
                    }

                    if(data.content.length){
                        PackageInputContent.value = data.content
                    } else {
                        PackageInputContent.value = []
                    }
                }
            }

            const uploadImage = () => {
                isModalFileListsShow.value = true
            }

            const eventSelected = (id) => {
                store.dispatch('files-folder/getFolderById', id)
                    .then(response => {
                        const res = response.data.data
                        images.value = res[0].images
    
                        const existingFolderId = Data?.value?.files[0]?.folder_id
    
                        if(model.value != existingFolderId){
                            selectedCoverImage.value = null
                            selectedImages.value = []
                        }
                })
            }
    
            const eventSelectedCoverImg = (data) => {
                const coverImg = selectedCoverImage.value
    
                if(coverImg == null){
                    selectedCoverImage.value = data
                    return
                }
    
                if(coverImg?.id == data.id){
                    selectedCoverImage.value = null
                    return
                }
            }
    
            const eventImgSelected = (data) => {
                const index = selectedImages.value.findIndex(item => item.id === data.id);
                index === -1 ? selectedImages.value.push(data) : selectedImages.value.splice(index, 1);
            }
    
            // const close = (hidden) => {
            //     for(const lang in oldValue.value?.title ?? {}) {
            //         Data.value.title[lang] = oldValue.value.title[lang]
            //     }
    
            //     for(const lang in oldValue.value?.slug ?? {}) {
            //         Data.value.slug[lang] = oldValue.value.slug[lang]
            //     }
    
            //     hidden()
            // }

            const refesh = () => {
                store.dispatch('files-folder/getFolders', {
                    parent: parent.value,
                    order_by:'ordering_count ASC'
                })
                    .then(response => {
                        const res = response.data.data
                        folders.value = res
                })

                model.value = null
                images.value = []
                selectedCoverImage.value = null
                selectedImages.value = []
            }

            const onSubmit = async () => {

                if (formObserver.value) {
                const isValid = await formObserver.value.validate();

                if (!isValid) {
                const errorMessages = Object.entries(formObserver.value.errors)
                    .filter(([key, message]) => message.length)
                    .map(([key, message]) => `${message}`)

                toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                    title: `Error`,
                    icon: 'BellIcon',
                    variant: 'danger',
                    text: `${errorMessages.join(" , ")}`,
                    },
                });

                return
                }
            }

                Data.value.is_active = Data.value.is_active?1:0;

                if(Data.value.id){
                    Data.value.cover_image = selectedCoverImage.value
    
                    if(!Data.value.cover_image){
                        Data.value.files = []
                    } else {
                        Data.value.files = selectedImages.value
                    }
                    
                    store.dispatch('app-packages/updatePackageData', Data.value)
                    .then((res) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Success`,
                                icon: 'BellIcon',
                                variant: 'success',
                                text: `${res.data.message}`,
                            },
                        });
    
                        emit('refetch-data')
                        emit('update:is-package-form-sidebar-active', false)
                    })
                    .catch((error) => {
                        toast({
                            component: ToastificationContent,
                            props: {
                                title: "Error Update Package",
                                icon: 'AlertTriangleIcon',
                                variant: 'danger',
                                text: error.response.data.message,
                            },
                        })
                    })

                } else {
                    Data.value.cover_image = selectedCoverImage.value
                    Data.value.files = selectedImages.value

                    store.dispatch('app-packages/addPackageData', Data.value)
                        .then((res) => {
                            toast({
                                component: ToastificationContent,
                                props: {
                                    title: `Success`,
                                    icon: 'BellIcon',
                                    variant: 'success',
                                    text: `${res.data.message}`,
                                },
                            });
        
                            emit('refetch-data')
                            emit('update:is-package-form-sidebar-active', false)
                        })
                        .catch((error) => {
                            toast({
                                component: ToastificationContent,
                                props: {
                                    title: "Error Add Room",
                                    icon: 'AlertTriangleIcon',
                                    variant: 'danger',
                                    text: error.response.data.message,
                                },
                            })
                        })
                }
            }

            const changeTitle  = (langCode, value) => {
                Data.value.slug[langCode] =  slugify(value)
            }

            const getLangs = (filter) => {
                store.dispatch("app-languages/fetchData", filter).then((res) => {
                    if (res.data.success) {
                        langs.value = res.data.data;
                    }
                });
            };

            let filter = {
                is_active:1,
                
            }

            getLangs(filter);

            const refeshList = async () => {
                emit("refetch-data");
            };

            const resetForm = () => {
                Data.value = blankData
            }

            const {
                getValidationState,
                refFormObserver
            } = formValidation(resetData);

            return {
                resetData,
                resetForm,
                getData,
                tabIndex,
                langs,
                getValidationState,
                Data,
                isModalFileListsShow,
                uploadImage,
                refesh,
                images,
                selectedCoverImage,
                refFormObserver,
                refeshList,
                onSubmit,
                changeTitle,
                eventSelectedCoverImg,
                eventImgSelected,
                eventSelected,
                toast,
                folders,
                images,
                model,
                selectedImages,
                PackageInputContentRemove,
                PackageInputContent,
                formObserver,
            }
        }
    }
</script>

<style lang="scss">
    @import "@core/scss/vue/libs/quill.scss";

    .selected-img{
        border: solid 5px #FFB341;
    }

    .disable-img{
        cursor: not-allowed;
        opacity: 0.5;
    }
</style>